import { useContext } from "react"
import { VerticalLayoutContext } from "../contexts/verticalContext"

export const useVertical = () => {
  const context = useContext(VerticalLayoutContext)

  return context
}
